"use strict";
/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalHouseContract = void 0;
/**
 * Contracts between the patient and the healthcare entity.
 */
class MedicalHouseContract {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.MedicalHouseContract = MedicalHouseContract;
(function (MedicalHouseContract) {
    MedicalHouseContract.ChangeTypeEnum = {
        InscriptionStart: 'inscriptionStart',
        InscriptionEnd: 'inscriptionEnd',
        Suspension: 'suspension',
        CoverageChange: 'coverageChange',
    };
    MedicalHouseContract.SuspensionReasonEnum = {
        NotInsured: 'notInsured',
        NoReasonGiven: 'noReasonGiven',
        IsHospitalized: 'isHospitalized',
        OutsideOfCountry: 'outsideOfCountry',
        ChangeOfMutuality: 'changeOfMutuality',
    };
    MedicalHouseContract.SignatureTypeEnum = {
        HolderEid: 'holderEid',
        HolderPaper: 'holderPaper',
        LegalrepresentativeEid: 'legalrepresentativeEid',
        LegalrepresentativePaper: 'legalrepresentativePaper',
    };
})(MedicalHouseContract = exports.MedicalHouseContract || (exports.MedicalHouseContract = {}));
//# sourceMappingURL=MedicalHouseContract.js.map